import * as React from 'react';
const defaultContext = {
    app: 'public',
    tier: 'live',
    apiBaseURL: 'https://www.telia.ee/api',
    isInsideParent: false,
};
export const EnvironmentContext = React.createContext(defaultContext);
